// extracted by mini-css-extract-plugin
module.exports = {"container":"DeviceFrame_container__38HUU","content":"DeviceFrame_content__1aHSY","shake":"DeviceFrame_shake__26u4J"};